module.exports = __webpack_public_path__ + "39859100164c0e8b1de9e8fe032378de.jpg";